import React from 'react';
import SharedNavbarTop from 'shared_items/NavbarTop';

// Wrapper de compatibilidade — preserva a assinatura original (activeTabL2, toggle settings/back).
// Implementação real em shared_items/NavbarTop.jsx (design-system fase 2). Remover em fase 3.
const NavbarTop = ({ title, onHomeClick, onLogoutClick, handleTabChange, activeTabL2 }) => (
  <SharedNavbarTop
    title={title}
    moduleKey="finance"
    onHomeClick={onHomeClick}
    zIndexClass="z-20"
    settingsActive={activeTabL2 === 'settings'}
    onSettingsClick={() => handleTabChange(activeTabL2 === 'settings' ? 'home' : 'settings')}
  />
);

export default NavbarTop;
